import { IconPack } from "runtime/registry/icons/types";
import filtersKeys from 'constants/filters';
import { WlConfig } from "./wlConfig";

 const config: WlConfig = {
    version: '0.0.0',
    name: 'centarium',
    iconLibrary: IconPack['thin'],
    components: {
      Loader: {
        props: {
          variant: 'ring',
        },
      },
      Header: {
        layout: {
          left: ['ChangeLang'],
          center: [],
          right: ['HelpDesk', 'Notifications', 'UserProfile'],
        },
      },
      UserProfile: {
        props: {},
        layout: {
          main: ['Name', 'GearIcon', 'Logout'],
        },
      },
      ChangeLang: {
        props: {
          panelCustomClass: 'ui-panel_left-side'
        }
      },
      LoginPage: {
        props: {
          layout: 'center'
        }
      },
      Home: {
        props: {
          isShowInstructionLink: true,
          currencyList: ['EUR', 'USD']
        }
      }
    },
    quickFiltersOverride: {
      payments: {
        [filtersKeys.paymentCurrency]: {
          hidden: true,
        },
        [filtersKeys.paymentType]: {
          list: {
            remove: ['purchase','recurring'],
            add: [
              {id: 'deposit', text: 'types.deposit' },
              {id: 'refund', text: 'types.refund' }
            ]
          },
        },
        [filtersKeys.paymentStatus]: {
          list: {
            remove: ['refunded'],
          },
        },
      },
      manualPayments: {
        [filtersKeys.status]: {
          list: {
            remove: ['awaiting clarification']
          }
        }
      },
      payouts: {
        [filtersKeys.paymentStatus]: {
          list: {
            remove: ['awaiting clarification']
          }
        }
      },
      massPayouts: {
        [filtersKeys.status]: {
          list: {
            remove: ['awaiting clarification']
          }
        }
      }
    },
    profileFieldsOverride: {
      favoriteCurrencies: {
        hidden: true
      },
      contactLang: {
        hidden: true
      }
    },
    isHideLinksOnPage: true,
    isHideSocialLinks: true,
    isHideBalanceFilters: true
  }
  export default config